import { LINKEDIN_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/linkedin-utils';

export const getLinkedInStepListConfig = i18n => [
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.LI_COMPANY_PAGE_LINKING,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.BUILD_ADS,
    title: i18n.getString(_TL_('Ads')),
    steps: [{
      id: LINKEDIN_WIZARD_STEP_PATHS.LINKEDIN_AD,
      isHidden: true,
    }, {
      id: LINKEDIN_WIZARD_STEP_PATHS.MULTI_AD_MANAGER,
      isHidden: true,
    }],
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.TARGETING,
    title: i18n.getString(_TL_('Targeting & conversions')),
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.BUDGET,
    title: i18n.getString(_TL_('Budget & bids')),
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.SUMMARY,
    title: i18n.getString(_TL_('Summary')),
  },
];
